import http from "infra/http";
import { useMutation } from "react-query";
import { TenantStatus } from "../typings/tenant";

function useToggleTenantStatus() {
  return useMutation(
    "/v1/tenants/mudar-status",
    async ({ tenantId, status }: { tenantId: string; status: TenantStatus }) =>
      http.put(`/v1/tenants/${tenantId}/mudar-status`, {
        status,
      })
  );
}

export default useToggleTenantStatus;
